import PaymentMethodTemplate from "../../../templates/admin/paymentMethod";

const PaymentMethodScreen = () => {
  return <PaymentMethodTemplate />;
};

export default PaymentMethodScreen;
